import { Button, Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUploadBenchmarkTest } from '@/entities/anonymizer-config';
import { FileButton } from '@/shared/ui';

export const BenchmarkTestingForm: FC = () => {
  const { t } = useTranslation('anonymizerConfig');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const { mutate: uploadTest, isPending } = useUploadBenchmarkTest();

  const handleUpload = () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append('file', selectedFile);
    uploadTest(formData, {
      onSuccess: () => {
        setSelectedFile(null);
      },
    });
  };

  return (
    <Card className="h-full flex flex-col overflow-hidden">
      <CardHeader className="shrink-0">
        <CardTitle>{t('fields.benchmarkTitle')}</CardTitle>
      </CardHeader>
      <CardContent className="flex-1 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <FileButton
            file={selectedFile}
            accept=".zip,.rar"
            label={t('fields.selectFile')}
            onChange={setSelectedFile}
          />
          {!selectedFile && <span className="text-sm text-muted-foreground">{t('fields.supportedFormats')}</span>}
          {selectedFile && (
            <Button onClick={handleUpload} isLoading={isPending}>
              {t('fields.uploadFile')}
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
